import { cLog } from '@lib/logging/client';
import { sLog } from '@lib/logging/server';
import { isServer } from '@lib/utils';

interface handleLogProps {
  message: string;
  metadata?: object;
}
export const handleLog = (
  level: 'debug' | 'info' | 'warn' | 'error' | 'trace',
  { message, metadata }: handleLogProps,
) => {
  const logger = isServer() ? sLog() : cLog();
  const logFn = (logger?.[level] ?? console?.[level] ?? console.log).bind(
    logger,
  );

  if (metadata) {
    logFn(message, JSON.stringify(metadata));
  } else {
    logFn(message);
  }
};
